import React, { useState, useEffect } from 'react';
import {
  Input,
  Button,
  Pagination,
  Select,
  Modal,
  Form,
  DatePicker,
  Switch,
} from 'antd';
import { Table, Space } from 'antd';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { FaRegEye, FaRegEdit } from 'react-icons/fa';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { AiOutlineDashboard } from 'react-icons/ai';
import { IoMdAdd } from 'react-icons/io';
import { MdDelete, MdArchive, MdEventNote } from 'react-icons/md';
import '../CaseCategory/CaseCategory.css';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Button as MuiButton } from '@mui/material';
import { Popover } from 'antd';
import moment from 'moment';
import ViewCaseDetails from './ViewCaseDetails';
import ViewFeeDetails from './ViewFeeDetails';
import AddFeeDetails from './AddFeeDetails';
import AddCourtDetails from './AddCourtDetails';
import ClientOptions from './ClientOptions';
import { useCases } from '../../hooks/useCases';
import { useClients } from '../../hooks/useClients';
const { Option } = Select;

const CaseModal = ({ visible, onCancel, onOk, caseData, isEdit }) => {
  const { useGetClients } = useClients();
  const { data: clientsData, isLoading: isClientsLoading } = useGetClients();

  const filteredClients = (clientsData || []).filter(
    client => client?.is_archive === false
  );

  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      if (isEdit && caseData) {
        const filingDate = caseData.filing_date
          ? moment(caseData.filing_date)
          : null;

        form.setFieldsValue({
          title: caseData.title,
          case_number: caseData.case_number,
          client: caseData.client?.id || caseData.client, // support both object and id
          is_starred: caseData.starred,
          filing_date: filingDate,
        });
      } else {
        form.resetFields();
      }
    }
  }, [visible, isEdit, caseData, form]);

  const onFinish = values => {
    onOk(values, isEdit ? caseData.id : null);
  };

  const [open, setOpen] = useState(false);

  const handleOpenChange = newOpen => {
    setOpen(newOpen);
  };

  const hide = () => {
    setOpen(false);
  };

  const handleView = () => {
    return (
      <Popover
        content={<a onClick={hide}>Close</a>}
        title="Title"
        trigger="click"
        open={open}
        onOpenChange={handleOpenChange}
      >
        <Button type="primary">Click me</Button>
      </Popover>
    );
  };

  return (
    <Modal
      title={isEdit ? 'Edit Case' : 'Add New Case'}
      open={visible}
      onOk={() => form.submit()}
      onCancel={onCancel}
      width={600}
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        initialValues={{ is_starred: false }}
      >
        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: 'Please enter the title' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="case_number"
          label="Case Number"
          rules={[{ required: true, message: 'Please enter the case number' }]}
        >
          <Input type="number" />
        </Form.Item>

        <Form.Item
          name="client"
          label="Client"
          rules={[{ required: true, message: 'Please select the client' }]}
        >
          <Select
            placeholder="Select Client"
            loading={isClientsLoading}
            showSearch
            optionFilterProp="children"
          >
            {filteredClients.map(client => (
              <Select.Option key={client.id} value={client.id}>
                {client.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="filing_date"
          label="Filing Date"
          rules={[{ required: true, message: 'Please select the filing date' }]}
        >
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name="is_starred" label="Starred" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const Cases = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentCase, setCurrentCase] = useState(null);
  const [fees, setFees] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [caseToDelete, setCaseToDelete] = useState(null);
  const pageSize = 10;

  const { useGetCases, useAddCase, useUpdateCase, useDeleteCase } = useCases();
  const { data: casesData, isLoading, isError, refetch } = useGetCases();
  const activeCases = casesData?.filter(item => !item.is_archive);

  const addCaseMutation = useAddCase();
  const updateCaseMutation = useUpdateCase();
  const deleteCaseMutation = useDeleteCase();

  const filteredData =
    activeCases?.filter(item => {
      return (
        item.title?.toLowerCase().includes(searchText?.toLowerCase()) ||
        item.case_number?.toString().includes(searchText)
      );
    }) || [];

  useEffect(() => {
    /* fetchfee(); */
  }, []);

  const fetchfee = async () => {
    try {
      const response = await axios.get(
        'http://admin.defconinnovations.com/advocateapi/case-fees/',
        {
          headers: {
            Authorization: `Token c404c955a08ca1779628c914e7692927074af875`,
          },
        }
      );

      setFees(response.data);
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  const showModal = (isEdit = false, caseItem = null) => {
    setIsEditMode(isEdit);
    setCurrentCase(caseItem);
    setIsModalVisible(true);
  };

  const handleOk = async (values, caseId = null) => {
    let filingDate = null;
    if (values.filing_date) {
      filingDate = values.filing_date.format
        ? values.filing_date.format('YYYY-MM-DD')
        : values.filing_date.toString();
    }

    const caseData = {
      title: values.title,
      case_number: values.case_number,
      client: values.client,
      filing_date: filingDate,
      starred: values.is_starred,
    };

    try {
      if (isEditMode && caseId) {
        await updateCaseMutation.mutateAsync({ id: caseId, data: caseData });
        alert('Case updated successfully');
      } else {
        await addCaseMutation.mutateAsync(caseData);
        alert('Case saved successfully');
      }
      setIsModalVisible(false);
      setIsEditMode(false);
      setCurrentCase(null);
    } catch (error) {
      console.error('Mutation error:', error);
      alert(`Failed to ${isEditMode ? 'update' : 'save'} case.`);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsEditMode(false);
    setCurrentCase(null);
  };

  const handleDelete = async caseId => {
    try {
      await deleteCaseMutation.mutateAsync(caseId);
      alert('Case deleted successfully');
    } catch (error) {
      console.error('Delete error:', error);
      alert('Failed to delete case');
    }
  };

  const handleSearch = e => {
    setSearchText(e.target.value);
  };

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  // const paginatedData = filteredData.slice(
  //   (currentPage - 1) * pageSize,
  //   currentPage * pageSize
  // );

  const startRecord =
    filteredData.length > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endRecord = Math.min(currentPage * pageSize, filteredData.length);
  const totalRecords = filteredData.length;

  const columns = [
    {
      title: 'Sr No',
      key: 'serialNumber',
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'Star',
      dataIndex: 'starred',
      key: 'starred',
      align: 'center',
      render: starred =>
        starred ? <FaStar style={{ color: '#1890ff' }} /> : <FaRegStar />,
    },
    {
      title: 'Case Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Case No',
      dataIndex: 'case_number',
      key: 'caseNumber',
    },
    {
      title: 'Client',
      dataIndex: 'client',
      key: 'client',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="small">
          <ViewCaseDetails item={record} />
          <ViewFeeDetails />
          <Button
            size="small"
            icon={<MdEventNote />}
            className="bg-success text-white"
          >
            Hearing Date
          </Button>
          <Button
            size="small"
            icon={<FaRegEdit />}
            className="bg-primary text-white"
            onClick={() => showModal(true, record)}
          >
            Edit
          </Button>
          <Button
            size="small"
            icon={<MdArchive />}
            className="bg-warning text-white"
          >
            Archived
          </Button>
          <Button
            size="small"
            icon={<MdDelete />}
            className="bg-danger text-white"
            onClick={() => {
              setCaseToDelete(record.id);
              setIsDeleteDialogOpen(true);
            }}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="mb-2 mt-2 p-4">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <h3>Case</h3>
          <h6 className="px-2 case-category">List</h6>
        </div>
        <div className="d-flex gap-2">
          <h6 className="d-flex align-items-center">
            <AiOutlineDashboard />
            Dashboard
          </h6>
          <h6 className="d-flex align-items-center">
            <MdKeyboardArrowRight />
            Case
          </h6>
        </div>
      </div>

      <div className="mt-2">
        <div className="d-flex justify-content-between mb-3">
          <div>
            {/* <div className='d-flex text-danger fs-5'>
              Filter Cases by Client / Court / Location / Case Stage / Filing
              Date / Hearing Date
            </div> */}
          </div>
          <div className="d-flex justify-content-between mb-3 gap-1">
            <AddFeeDetails />
            <Button
              onClick={() => showModal()}
              type="primary"
              icon={<IoMdAdd />}
            >
              Add New Case
            </Button>
            <AddCourtDetails />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md">
            <Select className="w-100" placeholder="--Filter By Client--">
              <Option value="all">All Clients</Option>
            </Select>
          </div>
          <div className="col-md">
            <Select className="w-100" placeholder="--Filter By Court--">
              <Option value="all">All Courts</Option>
            </Select>
          </div>
          <div className="col-md">
            <Select className="w-100" placeholder="--Filter By Location--">
              <Option value="all">All Locations</Option>
            </Select>
          </div>
          <div className="col-md">
            <Select className="w-100" placeholder="--Filter By Case Status--">
              <Option value="all">All Statuses</Option>
            </Select>
          </div>
          <div className="col-md">
            <Input placeholder="Filing Date" />
          </div>
          <div className="col-md">
            <Input placeholder="Hearing Date" />
          </div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between mb-3">
          <h5>Case</h5>
          <div className="d-flex gap-3 flex-column flex-md-row">
            <Button type="default" className="text-primary">
              Manage Hearing Dates of Case
            </Button>
            <Button type="default" className="text-primary">
              Manage Invoice & Receipt of Case
            </Button>
            <Button type="default" className="text-primary">
              Move Old Cases To Archived Cases
            </Button>
            <Button type="default" className="text-primary">
              Add Notes to Case
            </Button>
          </div>
        </div>
        <div className="d-flex mb-3 flex-column flex-md-row align-items-center">
          {/* <Select defaultValue="10" style={{ width: 80 }}>
            <Option value="10">10</Option>
            <Option value="20">20</Option>
            <Option value="50">50</Option>
          </Select>
          <span className="ms-2">records per page</span> */}
          <div className="ms-auto">
            <Input.Search
              placeholder="Search..."
              onChange={handleSearch}
              style={{ width: 200 }}
            />
          </div>
        </div>
        <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={activeCases || []}
            rowKey="id"
            pagination={false}
            bordered
          />
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              <span>
                Showing {startRecord} to {endRecord} of {totalRecords} entries
              </span>
            </div>
            <div>
              <Button type="link">Move Important Cases in Starred Cases</Button>
            </div>
            <div>
              <Button type="link">View / Edit Existing Case</Button>
            </div>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={filteredData.length}
              onChange={handlePageChange}
              showSizeChanger={false}
              size="small"
              itemRender={(page, type, originalElement) => {
                if (type === 'prev') {
                  return <Button size="small">← Previous</Button>;
                }
                if (type === 'next') {
                  return <Button size="small">Next →</Button>;
                }
                return originalElement;
              }}
            />
          </div>
        </div>
      </div>

      <CaseModal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        caseData={currentCase}
        isEdit={isEditMode}
      />

      <Dialog
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this case?
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={() => setIsDeleteDialogOpen(false)}>No</MuiButton>
          <MuiButton
            onClick={() => {
              handleDelete(caseToDelete);
              setIsDeleteDialogOpen(false);
            }}
            color="error"
          >
            Yes
          </MuiButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Cases;
